import React,{ useState, useEffect } from 'react';

import Remote from '../../images/hardware-setup/tv-remote.png';

function RemoteGuide() {

    return (
        <div id="stb-setup-component" className="modem-setup-component modem-connectivity-component">
            <h2>Remote Guide</h2>
            <h4>Overview</h4>
            <div className='hardware-setup-text-image-row'>
                <div className='copy'>
                    <div className='copy-divider'>
                        <p className="remote-label">1. TV/AUX</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Turn TV on or off</p>
                    </div>
                    <div className='copy-divider'>
                        <p className="remote-label">2. Source Select</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Displays and selects available video sources.</p>
                    </div>
                    <div className='copy-divider'>
                        <p className="remote-label">3. Microphone</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Voice commands*</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">4. STB Power</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Turn set-top box on or off</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">5. Colour Navigation</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Additional functions</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">6. Letter Keys</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Additional functions</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">7. Skip Backwards</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Go to previous track</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">8. Play/Pause</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Play and pause track</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">9. Skip Forward</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Go to next track</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">10. Stop</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Stop a running program</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">11. Record</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Begin recording current program</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">12. Menu</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Opens TV home menu</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">13. Arrow Up</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Moves the selection upwards</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">14. Guide</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Loads program guide</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">15. Arrow Left</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Moves the selection to the left</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">16. OK</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Selects the option that is highlighted</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">17. Arrow Right</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Moves the selection to right</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">18. Back/Exit</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Takes you back to previous screen, exits current screen</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">19. Home</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Go to main screen</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">20. Arrow Down</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Moves the selection down</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">21. Google Assistant</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Turns microphone on or off*</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">22. Volume Up/Down</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Turns the TV volume up or down</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">23. Mute</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Turns sound off</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">24. Channel Up/Down</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Moves the channels up or down</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">25. Number Pad</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Input numbers manually for selection</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">26. Info</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Loads information</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">27. Subtitles</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Turn subtitles on or off (when the feature is available)</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">28. Search</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Search shows, movies and live TV</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">29. Last</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Recalls/goes back to last selection</p>
                    </div>

                    <div className='copy-divider'>
                        <p className="remote-label">30. Low Battery Warning</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Indicates when remote battery is low</p>
                    </div>
                </div>
            </div>
            <h4>Colour Navigation & Letter Keys</h4>
            <div className='hardware-setup-text-image-row'>
                <div className='copy'>
                    <div className='copy-divider'>
                        <p className="remote-label">Red</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Access Start TV DVR Manager from within the Start TV Application</p>
                    </div>
                    <div className='copy-divider'>
                        <p className="remote-label">Green</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Load Start TV App from anywhere</p>
                    </div>
                    <div className='copy-divider'>
                        <p className="remote-label">Yellow</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Last Channel</p>
                    </div>
                    <div className='copy-divider'>
                        <p className="remote-label">Blue</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Access Start TV Settings Menu from within the Start TV Application</p>
                    </div>
                    <div className='copy-divider'>
                        <p className="remote-label">A</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Access Start TV Main Menu from within the Start TV Application</p>
                    </div>
                    <div className='copy-divider'>
                        <p className="remote-label">B</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Access Recordings inside the Start TV Main Menu</p>
                    </div>
                    <div className='copy-divider'>
                        <p className="remote-label">C</p>
                        <span className='divider'></span>
                        <p className="remote-button-description">Access Start TV On Demand module from within the Start TV Application</p>
                    </div>
                </div>
            </div>
            <img style={{ maxWidth: '320px' }} src={ Remote } />
        </div>
    )
}

export default RemoteGuide